import { useShellText } from "../../i18n/useShellText";
import { cn } from "../../utils/cn";
import { useTheme, type ThemeName } from "./ThemeProvider";
import { themeLabels } from "./themeLabels";

export const ThemeSwitcher = ({ compact, className }: { compact?: boolean; className?: string }) => {
  const { text: ui, t } = useShellText();
  const { theme, setTheme } = useTheme();
  const labels = themeLabels(t, t($ => $.light));

  return (
    <div
      role="radiogroup"
      aria-label={ui("Theme")}
      className={cn(
        "inline-flex shrink-0 items-center gap-0.5 rounded-full border border-border/70 bg-muted/80 p-0.5",
        compact ? "text-[11px]" : "text-xs",
        className
      )}
    >
      {(Object.keys(labels) as ThemeName[]).map((key) => {
        const active = key === theme;
        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setTheme(key)}
            className={cn(
              "whitespace-nowrap rounded-full px-2 py-0.5 font-medium transition-all",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/70 focus-visible:ring-offset-1 focus-visible:ring-offset-background",
              active
                ? "bg-card text-foreground shadow-subtle border border-border"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {labels[key]}
          </button>
        );
      })}
    </div>
  );
};
